export const alarmFieldsState = {
    errorCode : 0,
    statusCode : 0,
    alarmDataList : [],
    message : '',
    isLoading : false,
     regionList:[],
    predefinedTextList : []
}
